import React from 'react';
import PropTypes from "prop-types";
import { useTranslation } from 'react-i18next';
import CommonInputField from 'components/elements/inputs/CommonInputField';
import { connect } from 'react-redux';
import { setLastPatchedId } from 'redux/common/actions';
import { patchMenuLink } from 'redux/menu-links/actions';

function MenuLinkTitle(props) {
  const {
    patchMenuLink, 
    setLastPatchedId, 
    linkItem,
    patchMenuLinkError,
    lastPatchedId,
    maxLength,
    setError,
  } = props;

  const { t } = useTranslation();

  const validation = value => {
    if (!value) {
      setError(true);
      return t("Title should not be empty");
    }
    if (value) {
      if (value.length > 100) {
        return t("Ensure this field has no more than 100 characters");
      }
    }
    setError(false);
    return null;
  };

  return (
    <div className="menu-link-title__component">
      <CommonInputField
        key={`menu-link-title-input-${linkItem.id}`}
        editIcon
        initialValue={linkItem.title}
        validationFunction={validation}
        executedFunction={value => {
          const form = new FormData();
          form.append('title', value);
          patchMenuLink(linkItem.id, form);
          setLastPatchedId(linkItem.id);
        }}
        serverErrors={
          lastPatchedId === linkItem.id && patchMenuLinkError &&
          patchMenuLinkError.title
        }
        placeholder={t("Please enter the name of menu item")}
        maxLength={maxLength}
        maxLength={100}
      />
    </div>
  );
}

MenuLinkTitle.propTypes = {
  patchMenuLink: PropTypes.func.isRequired, 
    setLastPatchedId: PropTypes.func.isRequired, 
    linkItem: PropTypes.object.isRequired,
    patchMenuLinkError: PropTypes.object,
    lastPatchedId: PropTypes.number,
    maxLength: PropTypes.number,
    setError: PropTypes.func.isRequired,
}

MenuLinkTitle.defaultProps = {
  patchMenuLinkError: null,
  lastPatchedId: null,
}

const mapStateToProps = state => (
  {
    patchMenuLinkError: state.menuLinksReducer.patchMenuLinkError,
    lastPatchedId: state.commonReducer.lastPatchedId,
  }
);

export default connect(
  mapStateToProps,
  {
    patchMenuLink,
    setLastPatchedId,
  }
  ) (MenuLinkTitle);